import { Title } from "@/components/common/typography/Title";
import { TablerQuote } from "@/assets/icons/tabler-quote";

export const ConceptSection = () => {
  return (
    <section
      className="flex flex-col gap-12 px-4 py-20 text-black ph:px-24 md:px-48 lg:px-72 xl:px-96"
      id="concept"
    >
      <Title title="Le concept" />

      <div className="flex flex-col gap-5">
        <div className="mx-auto flex w-full max-w-5xl flex-col gap-4 text-center text-lg leading-relaxed md:text-2xl">
          <p>
            Un écosystème ouvert, stimulant et convivial, conçu pour favoriser
            les échanges et offrir un dynamisme unique.
          </p>
          <p>
            Travailler seul ne signifie plus être isolé. Rejoignez une
            communauté où les opportunités naissent des échanges et où chaque
            interaction peut ouvrir de nouvelles perspectives.
          </p>
        </div>

        <div className="flex w-full flex-row justify-center">
          <TablerQuote className="h-12 w-12 text-black" />
        </div>
      </div>
    </section>
  );
};
